var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.19689 5.77872L4.95689 1.53872C4.86392 1.44499 4.75332 1.3706 4.63146 1.31983C4.5096 1.26906 4.3789 1.24292 4.24689 1.24292C4.11487 1.24292 3.98417 1.26906 3.86231 1.31983C3.74045 1.3706 3.62985 1.44499 3.53689 1.53872C3.35064 1.72608 3.24609 1.97953 3.24609 2.24372C3.24609 2.5079 3.35064 2.76136 3.53689 2.94872L7.07689 6.48872L3.53689 10.0287C3.35064 10.2161 3.24609 10.4695 3.24609 10.7337C3.24609 10.9979 3.35064 11.2514 3.53689 11.4387C3.63033 11.5314 3.74114 11.6047 3.86298 11.6545C3.98482 11.7043 4.11528 11.7295 4.24689 11.7287C4.37849 11.7295 4.50896 11.7043 4.63079 11.6545C4.75263 11.6047 4.86345 11.5314 4.95689 11.4387L9.19689 7.19872C9.29061 7.10575 9.36501 6.99515 9.41578 6.87329C9.46655 6.75144 9.49268 6.62073 9.49268 6.48872C9.49268 6.35671 9.46655 6.226 9.41578 6.10414C9.36501 5.98228 9.29061 5.87168 9.19689 5.77872Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoArrow);
export default __webpack_public_path__ + "static/media/video-arrow.fc3ac1ef36e8958e9e9f2cdcf775a4f7.svg";
export { ForwardRef as ReactComponent };